import { toast } from 'react-toastify'
import { updateFileRoutine } from 'ducks/files/actions'
import { toggleUserPermissionsToFiles } from 'services/fileService'

export const removedUserIds = (file, selectedUsers) => (file?.users || []).filter(id => !selectedUsers.includes(id))

export const permissionsUnchanged = (file, selectedUsers) => {
  const before = new Set(file?.users || [])
  const after = new Set(selectedUsers)
  return before.size === after.size && [...before].every(id => after.has(id))
}

const saveFilePermissions = async ({ bpId, file, selectedUsers, dispatch }) => {
  const removed = removedUserIds(file, selectedUsers)

  const outcomes = await Promise.allSettled(
    removed.map(userId => toggleUserPermissionsToFiles(bpId, userId, [{ id: file.id, permission: false }]))
  )

  const stillHave = removed.filter((id, i) => outcomes[i].status === 'rejected')
  const firstFailure = outcomes.find(o => o.status === 'rejected')
  if (firstFailure) {
    toast.error(firstFailure.reason?.response?.data?.message || 'Could not remove access for some people. Please try again.')
  }

  dispatch(
    updateFileRoutine({
      id: file.id,
      bpId,
      fileVersionId: file.versions?.[0]?.id || '',
      body: { userIds: [...selectedUsers, ...stillHave] }
    })
  )
}

export default saveFilePermissions
